import api from "~/services/api";

const CONTROLLER_NAME = "/business";
const BOOKING_CONTROLLER_NAME = "/booking_transaction";

export const packagesList = (businessId, language) => {
    return api.get(`${CONTROLLER_NAME}/${businessId}/packages?language=${language}`);
}

export const addSchedulingPackage = (categoryId, body) => {
    return api.post(`${BOOKING_CONTROLLER_NAME}?language=portuguese&category_id=${categoryId}`, body);
}

export const packageBookings = (businessId, page, perPage, language, filter) => {
    let filterParam = "";
    if (filter === "activated") filterParam = "&activated=true";
    else if (filter === "pending_payment") filterParam = "&pending_payment=true";
    // filter === "all" ou undefined → sem parâmetro de status
    return api.get(`${CONTROLLER_NAME}/${businessId}/packages/bookings?page=${page}&per_page=${perPage}&language=${language}${filterParam}`);
}

export const activePackageSessions = (businessId, services) => {
    if (!services || services.length === 0) throw new Error("activePackageSessions: services é obrigatório");
    return api.post(`${CONTROLLER_NAME}/${businessId}/active_package_sessions`, { services });
}

export default {
	packagesList,
    addSchedulingPackage,
    packageBookings,
    activePackageSessions
};
